// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  warId: __t.u64().primaryKey().name("war_id"),
  worldId: __t.u64().name("world_id"),
  stakeSid: __t.u64().name("stake_sid"),
  stakeCiv: __t.string().name("stake_civ"),
  defenderLosses: __t.u32().name("defender_losses"),
  battlesAtStake: __t.u32().name("battles_at_stake"),
  updatedAt: __t.timestamp().name("updated_at"),
});
